export default "__VITE_ASSET__ac935f71__"